import { Swiper, Navigation, A11y } from 'swiper';
import { theme } from '../../constants/defaults';
import cartModalTemplate from '../../templates/cartModalTemplate';
import Cart from './Cart';
import quantitySelect from '../layout/quantitySelect';
import quickAddToCart from '../layout/quickAddToCart';

Swiper.use([Navigation, A11y]);

export default class CartModal {
  constructor() {
    if (theme.settings.ajaxCartEnabled) {
      this.cart = Cart.getInstance();
      this.cartContainer = document.getElementById('cart-container');

      const modalNamespace = 'cart-modal';
      this.modal = window.modalManager.idModalMap.get(modalNamespace);

      this.modal.on('before-show', () => {
        this.cartContainer.innerHTML = cartModalTemplate(true);

        this.cart.getState().then((state) => {
          this.buildCart(state);
        });
      });

      // If the quantity specified is more then what is available,
      // the promise will still be fullfilled and
      // the maximum number of available items is added to the cart.
      // So we need to update the input field with the quantity in the cart
      this.cart.on('updated', (state) => {
        this.buildCart(state);
      });
    }
  }

  buildCart(initialState) {
    this.cartContainer.innerHTML = cartModalTemplate(false, initialState);

    // Init slider
    new Swiper('.slider--upsell', {
      direction: 'horizontal',
      slidesPerView: 1.2,
      centeredSlides: true,
      preloadImages: true,
      loop: true,
      spaceBetween: 10,
      updateOnImagesReady: true,
      effect: 'fade',
      a11y: true,
      navigation: {
        nextEl: '.swiper-button-next-upsell',
        prevEl: '.swiper-button-prev-upsell',
      },
    });

    // Update cart when quantity of item has changed
    const qtySelects = [...this.cartContainer.querySelectorAll('.js-quantity-select')];
    const qtySelectCallback = (input, quantity) => {
      const { key } = input.dataset;
      const itemEl = this.cartContainer.querySelector(`.ajaxcart__product[data-key="${key}"]`);

      if (quantity === 0) {
        // Remove item
        itemEl.classList.add('is-removing');
        this.cart.removeItem(key).then(() => {
          itemEl.parentNode.removeChild(itemEl);
        });
      } else {
        // Update item
        itemEl.classList.add('is-updating');
        this.cart.updateItem(key, { quantity }).then(() => {
          itemEl.classList.remove('is-updating');
        });
      }
    };

    quantitySelect(qtySelects, qtySelectCallback);

    // Update note
    const note = this.cartContainer.querySelector('textarea[name="note"]');
    if (note) {
      note.addEventListener('change', () => {
        this.cart.updateNote(note.value);
      });
    }

    // Add to cart
    const addToCartButtons = [...this.cartContainer.querySelectorAll('.js-add-to-cart-button')];
    quickAddToCart(addToCartButtons, this.cart);

    this.cartContainer.querySelectorAll('.js-modal-close').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.modal.hide();
      });
    });
  }
}
